import { ReactComponent as SadFace } from '@cobliteam/ui-business/icons/face-id/sad-face.svg';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

interface MainFaceImageProps {
  src?: string;
  isLoading?: boolean;
}

const MainFaceImage = ({ src, isLoading = false }: MainFaceImageProps) => {
  const content = () => {
    if (isLoading) return <Icon name='loader-circle' className='animate-spin' />;

    return src ? <img src={src} className='aspect-square size-full rounded-full bg-gray-4 object-contain' alt='' /> : <SadFace className='text-primary' />;
  };

  return <div className={cn('flex size-16 items-center justify-center overflow-hidden rounded-full border border-primary-7 bg-primary-2', src && 'border-white')}>{content()}</div>;
};

export default MainFaceImage;
